import { useTranslation } from 'react-i18next'
import { useUpdateDestinationMutation } from '@/entities/destination'
import { getApiErrorText } from '@/shared/libs/get-api-error-text'
import { showToast } from '@/shared/libs/toast'
import { StatusToggleWithConfirm } from '@/shared/ui/status-toggle-with-confirm'

interface DestinationStatusToggleProps {
  destinationId: string
  isActive: boolean
}

export function DestinationStatusToggle({ destinationId, isActive }: DestinationStatusToggleProps) {
  const { t } = useTranslation()
  const updateMutation = useUpdateDestinationMutation()

  async function handleConfirmed() {
    try {
      await updateMutation.mutateAsync({
        id: destinationId,
        payload: { isActive: !isActive },
      })
      showToast.success(
        t('common.operationSuccess', { defaultValue: 'Status updated successfully' }),
      )
    } catch (error) {
      showToast.error(getApiErrorText(error) ?? t('common.operationFailed'))
    }
  }

  return (
    <div className="flex justify-center">
      <StatusToggleWithConfirm
        checked={isActive}
        pending={updateMutation.isPending}
        confirmEnableTitle={t('common.confirmEnable', { defaultValue: 'Enable this destination?' })}
        confirmDisableTitle={t('common.confirmDisable', {
          defaultValue: 'Disable this destination?',
        })}
        onConfirmed={handleConfirmed}
      />
    </div>
  )
}
